/* src/app/confirmation-dialog/confirmation-dialog.component.scss */
.d-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(16, 24, 40, 0.45);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  animation: dialog-overlay-in 0.2s ease;
}
.dialog {
  width: 100%;
  max-width: 470px;
  overflow: hidden;
  border: 1px solid #eaecf0;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 24px 60px rgba(16, 24, 40, 0.18), 0 4px 12px rgba(16, 24, 40, 0.06);
  animation: dialog-in 0.22s ease;
  outline: none;
}
.dialog-header {
  padding: 22px 22px 18px;
  display: flex;
  align-items: flex-start;
  gap: 15px;
  border-bottom: 1px solid #f0f2f5;
  background:
    linear-gradient(
      180deg,
      #ffffff 0%,
      #fcfcfd 100%);
}
.dialog-icon {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #fedf89;
  border-radius: 12px;
  background: #fffaeb;
  color: #d97706;
  font-size: 21px;
  box-shadow: 0 3px 8px rgba(217, 119, 6, 0.08);
}
.dialog-heading {
  min-width: 0;
  flex: 1;
}
.dialog-title-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.dialog-heading h5 {
  margin: 1px 0 0;
  color: #101828;
  font-size: 20px;
  line-height: 1.35;
  font-weight: 700;
  letter-spacing: -0.2px;
}
.dialog-subtitle {
  display: block;
  margin-top: 5px;
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}
.dialog-close {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -3px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #667085;
  font-size: 15px;
  cursor: pointer;
  transition:
    background 0.18s ease,
    color 0.18s ease,
    transform 0.18s ease;
}
.dialog-close:hover {
  background: #f2f4f7;
  color: #344054;
  transform: scale(1.03);
}
.dialog-close:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.15);
  outline-offset: 2px;
}
.dialog-body {
  padding: 22px;
  background: #ffffff;
}
.dialog-message {
  color: #344054;
  font-size: 15px;
  line-height: 1.7;
  word-break: break-word;
}
.dialog-message p {
  margin: 0 0 10px;
}
.dialog-message p:last-child {
  margin-bottom: 0;
}
.dialog-message strong,
.dialog-message b {
  color: #101828;
  font-weight: 650;
}
.dialog-message ul,
.dialog-message ol {
  margin: 10px 0;
  padding-left: 22px;
}
.dialog-message li {
  margin-bottom: 5px;
}
.dialog-message a {
  color: #253b80;
  text-decoration: underline;
}
.dialog-footer {
  padding: 16px 22px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid #eaecf0;
  background: #f9fafb;
}
.dialog-footer .btn {
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 17px;
  border-radius: 9px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1;
  font-weight: 650;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    color 0.18s ease,
    box-shadow 0.18s ease,
    transform 0.18s ease;
}
.dialog-footer .btn:active {
  transform: translateY(1px);
}
.dialog-footer .btn:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.15);
  outline-offset: 2px;
}
.dialog-footer .btn-cancel {
  border: 1px solid #d0d5dd;
  background: #ffffff;
  color: #344054;
}
.dialog-footer .btn-cancel:hover {
  border-color: #b8c0cc;
  background: #f9fafb;
}
.dialog-footer .btn-confirm {
  border: 1px solid #253b80;
  background: #253b80;
  color: #ffffff;
  box-shadow: 0 3px 8px rgba(37, 59, 128, 0.16);
}
.dialog-footer .btn-confirm:hover {
  border-color: #1f326d;
  background: #1f326d;
  box-shadow: 0 5px 12px rgba(37, 59, 128, 0.22);
}
.dialog-footer .btn-confirm i {
  font-size: 13px;
}
@keyframes dialog-overlay-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes dialog-in {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 600px) {
  .d-overlay {
    padding: 15px;
  }
  .dialog {
    max-width: 100%;
    border-radius: 16px;
  }
  .dialog-header {
    padding: 20px 18px 16px;
    gap: 12px;
  }
  .dialog-icon {
    width: 42px;
    height: 42px;
    flex-basis: 42px;
    font-size: 19px;
  }
  .dialog-heading h5 {
    font-size: 18px;
  }
  .dialog-subtitle {
    font-size: 13px;
  }
  .dialog-body {
    padding: 20px 18px;
  }
  .dialog-message {
    font-size: 14px;
    line-height: 1.65;
  }
  .dialog-footer {
    padding: 14px 18px;
  }
}
@media (max-width: 430px) {
  .d-overlay {
    padding: 12px;
  }
  .dialog {
    border-radius: 14px;
  }
  .dialog-header {
    padding: 18px 16px 15px;
  }
  .dialog-icon {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
    border-radius: 10px;
    font-size: 18px;
  }
  .dialog-heading h5 {
    font-size: 17px;
  }
  .dialog-subtitle {
    font-size: 12px;
  }
  .dialog-close {
    width: 32px;
    height: 32px;
    flex-basis: 32px;
  }
  .dialog-body {
    padding: 18px 16px;
  }
  .dialog-message {
    font-size: 14px;
    line-height: 1.65;
  }
  .dialog-footer {
    padding: 14px 16px;
    flex-direction: column-reverse;
    align-items: stretch;
  }
  .dialog-footer .btn {
    width: 100%;
    min-height: 44px;
    font-size: 14px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .d-overlay,
  .dialog {
    animation: none;
  }
  .dialog-close,
  .dialog-footer .btn {
    transition: none;
  }
}
/*# sourceMappingURL=confirmation-dialog.component.css.map */
